<template>
    <tr data-component="KitchenOrderDetailsItemRow">
        <td>
            {{ item.qty }} x {{ item.itemName }}
            <ul v-if="hasItemOptionValues"
                class="kitchen-order-details-table__fields">
                <li v-for="option in item.itemOptions"
                    :key="option.key">
                    <span>{{ option.itemName }}</span>
                </li>
            </ul>
            <ul v-if="hasCustomFieldValues"
                class="kitchen-order-details-table__fields">
                <li v-for="field in item.fieldData"
                    :key="field.fieldID">
                    <span v-for="answer in field.answer"
                          :key="answer"
                          :class="{
                              'stand-out-text': answer.indexOf('!') !== -1,
                          }">
                        {{ answer }}
                    </span>
                </li>
            </ul>
        </td>
        <td class="kitchen-order-details-table__qty-cell">
            <span v-if="item.qtyFulfilled > 0"
                  class="label"
                  :class="hasOutstandingQty ? 'label-default' : 'label-success'">
                {{ item.qtyFulfilled }} x {{ l('KITCHEN_ORDER_DETAILS.QTY__FULFILLED') }}
            </span>
        </td>
        <td class="kitchen-order-details-table__qty-cell">
            <span v-if="hasOutstandingQty"
                  class="label label-warning">
                {{ item.qtyUnfulfilled }} x {{ l('KITCHEN_ORDER_DETAILS.QTY__PENDING') }}
            </span>
        </td>
        <td>
            <template v-if="item.kitchenZoneIDs?.length > 0">
                {{ kitchenZoneNames }}
            </template>
            <template v-else>
                <em>{{ l('KITCHEN_ORDER_DETAILS.ALL_ZONES' ) }}</em>
            </template>
        </td>
    </tr>
</template>

<script>
import { container } from '@/container';

export default {
    props: {
        /**
         * @type {KitchenOrderItem}
         */
        item: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            kitchenZoneNames: '',
        };
    },

    computed: {
        hasOutstandingQty() {
            return this.item.qtyUnfulfilled > 0;
        },

        hasCustomFieldValues() {
            return this.item.fieldData && Object.keys(this.item.fieldData).length > 0;
        },

        hasItemOptionValues() {
            return this.item.itemOptions && this.item.itemOptions.length > 0;
        },
    },

    created() {
        // Load the kitchen zone names.
        if (this.item.kitchenZoneIDs) {
            this.loadKitchenZoneNames();
        }
    },

    methods: {
        async loadKitchenZoneNames() {
            let names = [];
            await Promise.all(
                this.item.kitchenZoneIDs.map((kitchenZoneID) => {
                    return container.kitchenZoneRepository.find(kitchenZoneID).then((kitchenZone) => {
                        names.push(kitchenZone.name);
                    });
                })
            );
            names.sort();
            this.kitchenZoneNames = names.join(', ');
        },
    },
};
</script>
